import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":"380px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('sign-in',{on:{"loginSuccess":_vm.loginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }